/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-18 10:33:30
 *
 *******************************************************/
// @flow
import React from 'react';
import { Icon, TextField } from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';

type ComposedProps = {
  queryValue: string,
  onQueryChange: Function,
  handleKeyUp: Function,
  handleKeyDown: Function
};

const FiltersBar = (props: ComposedProps) => {
  const { i18n, queryValue, onQueryChange, handleKeyUp, handleKeyDown } = props;

  return (
    <div className="BC-Filters">
      <div className="BC-Filters-ConnectedFilterControl">
        <div className="BC-Filters-ConnectedFilterControl__RightContainer">
          <div className="search" onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
            <TextField
              onChange={onQueryChange}
              value={queryValue}
              prefix={<Icon source={SearchMinor} color="base" />}
              placeholder={i18n.translate('AdminHTML.PredictiveBundle.searchTextField_Placeholder')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withI18n()(FiltersBar);
